import { createReducer, createActions } from 'reduxsauce'

export const { Types, Creators } = createActions({
  connectionRestored: null,
  connectionLost: ['error'],

  clear: null,
})

export const ConnectivityTypes = Types
export default Creators

const INITIAL_STATE = {
  isConnected: true,
  error: null,
}

const connectionRestored = state => ({
  ...state,
  isConnected: true,
  error: null,
})

const connectionLost = (state, action) => ({
  ...state,
  error: action.error,
  isConnected: false,
})

const clear = () => INITIAL_STATE

const HANDLERS = {
  [Types.CONNECTION_RESTORED]: connectionRestored,
  [Types.CONNECTION_LOST]: connectionLost,

  [Types.CLEAR]: clear,
}

export const reducer = createReducer(INITIAL_STATE, HANDLERS)
